import { useLeafletContext } from '@react-leaflet/core'
import L from "leaflet";
import { JSX, useEffect, useState } from "react";

interface LegendProps {
  buckets: number[][];
  colors: string[];
  bySpecialty: boolean;
  removeLegend: boolean;
}

const Legend = (props: LegendProps): JSX.Element => {
  const context = useLeafletContext()
  const legend = new L.Control();
  const [prevLegend, setPrevLegend] = useState<L.Control>();

  useEffect(() => {

    if (props.removeLegend === true) {
      if (prevLegend)
        context.map.removeControl(prevLegend);
      setPrevLegend(null);
      return;
    }

    legend.onAdd = () => {
      const div = L.DomUtil.create("div", "legend p-2");

      div.innerHTML += "<h6>Map: Legend</h6>";
      div.innerHTML += "<p>Gap Count per County</p>";

      const labels = [];
      const border = "1px solid #ffffff";

      if (props.bySpecialty) {
        labels.push(`<i style="background-color: ${props.colors[0]}; border: ${border}"></i><span>0</span>`);
        labels.push(`<i style="background-color: ${props.colors[props.colors.length - 1]}; border: ${border}"></i><span>1</span>`);
      }
      else {
        for (let i = 0; i < props.buckets.length; i++) {
          const low = props.buckets[i][0];
          const high = props.buckets[i][1];
          labels.push(
            `<i style="background-color: ${props.colors[i]}; border: ${border}"></i>
            <span>${low}${i === 0 || low === high ? `` : ` &ndash; ${high}`}</span>`
          );
        }
      }
      div.innerHTML += labels.join("<br>");
      return div;
    };

    legend.addTo(context.map);

    if (prevLegend)
      context.map.removeControl(prevLegend);

    setPrevLegend(legend);

  }, [props.bySpecialty, props.removeLegend === true]);

  return null;
};

export default Legend;
